<template>
  <div class="recipe_add">
    <br />

    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: 'SignCheck' }">申请处方</el-breadcrumb-item>

      <el-breadcrumb-item>审核中</el-breadcrumb-item>
    </el-breadcrumb>

    <hr />

    <el-tabs v-model="activeName" type="card">
      <el-tab-pane label="审核中" name="first">
        <el-container>
          <!-- <el-header> 空置区域 </el-header> -->
          <el-main>
            <el-form ref="form" :model="form" label-width="100px">
              <table width="100%">
                <tr>
                  <td style="width:300px">
                    <el-form-item label="开始时间" prop="startTime">
                      <el-date-picker
                        v-model="form.startTime"
                        format="yyyy-MM-dd "
                        value-format="yyyy-MM-dd "
                        clearable
                        style="width:200px"
                        :picker-options="startDatePicker"
                        type="date"
                        placeholder="请输入查询开始时间"
                      ></el-date-picker>
                    </el-form-item>
                  </td>
                  <td>
                    <el-form-item label="结束时间" prop="endTime">
                      <el-date-picker
                        v-model="form.endTime"
                        format="yyyy-MM-dd "
                        value-format="yyyy-MM-dd "
                        clearable
                        style="width: 200px"
                        :picker-options="endDatePicker"
                        type="date"
                        placeholder="请输入查询结束时间"
                      ></el-date-picker>
                    </el-form-item>
                  </td>
                </tr>
                <tr></tr>
              </table>
            </el-form>
            <el-form label-width="30px">
              <el-form-item>
                <el-button type="primary" @click="onSubmit()">查询</el-button>
              </el-form-item>
            </el-form>

            <!-- <div class="form-region-header font-30"></div>  -->
            <table width="100%">
              <tr>
                <td>
                  <el-table
                    :data="auditTableData.slice((currentPage-1)*pageSize,currentPage*pageSize)"
                    style="width: 100%"
                  >
                    <el-table-column prop="date" label="提交时间" width="180"></el-table-column>
                    <el-table-column prop="customerName" label="客户" width="180"></el-table-column>
                    <el-table-column prop="customerPhone" label="手机号码" width="180"></el-table-column>
                    <el-table-column prop="status" label="当前状态" width="200"></el-table-column>
                    <el-table-column prop="operation" label="操作">
                      <template slot-scope="scope">
                        <el-button
                          v-if ="scope.row.toContinue===false"
                          v-show="scope.row.active === true"
                          :disabled="!scope.row.active === true"
                          type="primary"
                          icon="el-icon-search"
                          @click="onCheckSuccess(scope.row.recipeID)"
                        >查看处方</el-button>
                        <el-button
                          v-else 
                          type="primary"
                          @click="onContinueAdd(scope.row.recipeID)"
                        >继续提交</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </td>
              </tr>
              <tr>
                <td>
                  <!-- <el-button type="primary" @click="passall">全部通过</el-button> -->
                </td>
              </tr>
            </table>
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="currentPage"
              :page-size="pageSize"
              layout="total, prev, pager, next,jumper"
              :total="currentTotal"
            ></el-pagination>
          </el-main>
        </el-container>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import qs from "qs";

export default {
  name: "Audit",
  data() {
    return {
      offsetDays: 5, //默认多少天前的数据开始显示

      currentPage: 1,
      pageSize: 30,
      currentTotal: 0,

      activeName: "first",
      form: {
        startTime: "",
        endTime: ""
      },

      startDatePicker: this.beginDate(),
      endDatePicker: this.processDate(),
      formBinds: {},
      reviewCasesByDateRangeApi: "https://yc.suyizaixian.com:30005/reviewCasesByDateRange",
      auditTableData: [],
      rules: {}
    };
  },
  props: {
    msg: String
  },
  methods: {
    beginDate() {
      const self = this;
      return {
        disabledDate(time) {
          if (self.form.endTime) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.form.endTime).getTime() < time.getTime();
          } else {
            var timeNow = Date.now();
            return time.getTime() > timeNow;
          }
        }
      };
    },
    processDate() {
      const self = this;
      return {
        disabledDate(time) {
          if (self.form.startTime) {
            //如果开始时间不为空，则结束时间大于开始时间
            var timeNow = Date.now();
            return (
              time.getTime() < new Date(self.form.startTime).getTime() ||
              time.getTime() > timeNow
            );
          } else {
            return time.getTime() > timeNow;
          }
        }
      };
    },

    onSubmit() {

      var __this = this;
      let start = new Date(__this.form.startTime);
      start.setHours(0, 0, 0, 0);
      start.setDate(start.getDate() );
      let end = new Date(__this.form.endTime);
      end.setHours(23, 59, 59, 999);
      //TODO comment the hard code/
      let params = {
        startDate: __this.toJSONLocalDate(start),
        endDate: __this.toJSONLocalDate(end),
        authToken: sessionStorage.getItem("authToken")
      };
      //console.log(params);
      __this.auditTableData=[];
      const promise1 = this.axios.post(
        __this.reviewCasesByDateRangeApi,
        qs.stringify(params)
      );
      Promise.all([promise1]).then(function(results) {
        for (let result of results) {
          if (result.data.data.result === "success") {
            // console.log(result.data.data.result);
            // console.log(result.data.data);
            if (result.data.data.CasesList !== undefined) {
              __this.currentTotal = result.data.data.CasesList.length;
              for (let caseItem of result.data.data.CasesList) {
                __this.auditTableData.push({
                  recipeID: caseItem.recipeID,
                  date: __this.toJSONLocalDate(new Date(caseItem.submitTime)),
                  customerName: caseItem.customerName,
                  customerPhone:caseItem.customerPhone,
                  status: __this.generateStrStatus(caseItem.pspStatus),
                  active: caseItem.pspStatus === 6 ? true : false,                
                  toContinue: caseItem.pspStatus === 1 ? true : false
                });
              }
            }else{
              __this.currentTotal=0;
              __this.auditTableData=[];
            }
          }
        }
        //console.log(__this.auditTableData);
      }).catch((e) => { alert(e+"，登录超时，请重新登录");});
    },
    generateStrStatus(status) {
      let strStatus;
      switch (status) {
        case 1:
          strStatus = "订单尚未提交";
          break;
        case 2:
          strStatus = "等待医生处理";
          break;
        case 3:
          strStatus = "医生处理中";
          break;
        case 4:
          strStatus = "等待药师处理";
          break;
        case 5:
          strStatus = "药师处理中";
          break;
        case 6:
          strStatus = "处方申请成功";
          break;

        case 10:
          strStatus = "医师拒绝处方";
          break;

        case 11:
          strStatus = "药师拒绝处方";
          break;
      }
      return strStatus;
    },
    onCheckSuccess(PrintRecipeID) {
      console.log("PrintRecipeID" + PrintRecipeID);
      sessionStorage.setItem("PrintRecipeID", PrintRecipeID);
      let routeData = this.$router.resolve({
          path: "/RecipePrint",
        query: {}
        });

      window.open(routeData.href, "_blank");  

    },

    onContinueAdd(RecipeID) {
      sessionStorage.setItem("recipeID", RecipeID);
      // this.$router.replace("/RecipePrint");
      this.$router.replace("/RecipeAdd3");
    },

    toJSONLocalDate(date) {
      var local = new Date(date);
      local.setMinutes(date.getMinutes() - date.getTimezoneOffset());
      return local
        .toJSON()
        .slice(0, 16)
        .replace("T", " ");
    },
    passall(formName) {
      console.log(formName);
      this.$confirm("是否同意?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.axios
            .get(this.DoctorApprovalApi)
            .then(response => (this.info = response.data))
            .catch(function(err) {
              alert(err);
            });
        }).catch((e) => { alert(e+"，登录超时，请重新登录");});
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    // 分页相关
    handleSizeChange(val) {
      this.pageSize = val;
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      console.log(`当前页: ${val}`);
    }
  },
  mounted() {
    if (sessionStorage.getItem("authToken") == null||sessionStorage.getItem("authToken").trim()==""){
      this.$router.replace("/Login");
    }else{
    var __this = this;
    let start = new Date();
    start.setHours(0, 0, 0, 0);
    start.setDate(start.getDate() - __this.offsetDays);
    let end = new Date();
    end.setHours(23, 59, 59, 999);
    //TODO comment the hard code/
    let params = {
      startDate: __this.toJSONLocalDate(start),
      endDate: __this.toJSONLocalDate(end),
      authToken: sessionStorage.getItem("authToken")
    };

    __this.form.startTime = new Date(start);
    __this.form.endTime = new Date(end);
    //let params = {'startDate':'2019-08-25 00:09:00', 'endDate':'2019-09-17 07:42:50'};
    //console.log("+++++date range is "+params);
    const promise1 = this.axios.post(
      __this.reviewCasesByDateRangeApi,
      qs.stringify(params)
    );
    Promise.all([promise1]).then(function(results) {
      for (let result of results) {
        if (result.data.data.result === "success") {
          // console.log(result.data.data.result);
          // console.log(result.data.data);
          if (result.data.data.CasesList !== undefined) {
            __this.currentTotal = result.data.data.CasesList.length;
            for (let caseItem of result.data.data.CasesList) {
              __this.auditTableData.push({
                recipeID: caseItem.recipeID,
                date: __this.toJSONLocalDate(new Date(caseItem.submitTime)),
                customerName: caseItem.customerName,
                customerPhone:caseItem.customerPhone,
                status: __this.generateStrStatus(caseItem.pspStatus),
                active: caseItem.pspStatus === 6 ? true : false,
                toContinue: caseItem.pspStatus === 1 ? true : false
              });
            }
          }
        }
      }
      //console.log(__this.auditTableData);
    });

    // this.axios.post(__this.reviewCasesByDateRange, qs.stringify(params))
    // .then(function(res) {
    //   if(res.data.data.result==="success"){
    //     if(res.data.data.todayCasesList!==undefined){
    //         for(let caseItem of res.data.data.submittedList){
    //           __this.auditTableData.push({
    //             date: __this.toJSONLocalDate(new Date(caseItem.submitTime)),
    //             customerName: caseItem.customerName,
    //             status: __this.generateStrStatus(caseItem.pspStatus),
    //             active: caseItem.pspStatus===6 ? true : false
    //           });
    //         }
    //       }
    //   }
    // });
  }
  }
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
